// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  general: {
    app: path(ROOTS_DASHBOARD, '/home'),
  },

  products: {
    root: path(ROOTS_DASHBOARD, '/products'),
    viewAll: path(ROOTS_DASHBOARD, '/products/all'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/products/${name}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/products/edit/${id}`),
    add: path(ROOTS_DASHBOARD, '/products/add'),
    import: path(ROOTS_DASHBOARD, '/products/import-product'),
    importRates: path(ROOTS_DASHBOARD, '/products/import-rates'),
  },

  account: {
    root: path(ROOTS_DASHBOARD, '/account'),
    info: path(ROOTS_DASHBOARD, '/account/info'),
    bulkPayment: path(ROOTS_DASHBOARD, '/account/bulk-payment'),
    reports: path(ROOTS_DASHBOARD, '/account/reports'),
  },

  users: {
    root: path(ROOTS_DASHBOARD, '/users'),
    add: path(ROOTS_DASHBOARD, '/users/add'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/users/edit/${id}`),
    import: path(ROOTS_DASHBOARD, '/users/import'),
    profile: path(ROOTS_DASHBOARD, '/users/profile'),
    account: path(ROOTS_DASHBOARD, '/users/account'),
  },

  companies: {
    root: path(ROOTS_DASHBOARD, '/companies'),
    viewAll: path(ROOTS_DASHBOARD, '/companies/all'),
    add: path(ROOTS_DASHBOARD, '/companies/add'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/companies/edit/${id}`),
    import: path(ROOTS_DASHBOARD, '/companies/import'),
    manageProduct: (id: string) => path(ROOTS_DASHBOARD, `/companies/manage-products/${id}`),
    profile: path(ROOTS_DASHBOARD, `/companies/profile`)
  },

  orders: {
    root: path(ROOTS_DASHBOARD, '/orders'),
    viewAll: path(ROOTS_DASHBOARD, '/orders/all'),
    manage: path(ROOTS_DASHBOARD, '/orders/manage'),
    edit: (id: string, date: string) => path(ROOTS_DASHBOARD, `/orders/edit/${id}/${date}`),
    distributorSummary: (id: string, date: string) => path(ROOTS_DASHBOARD, `/orders/summary/${id}/${date}`),
    auditLogs: path(ROOTS_DASHBOARD, '/orders/audit-logs'),
  },

  vehicles: {
    root: path(ROOTS_DASHBOARD, '/vehicles'),
    viewAll: path(ROOTS_DASHBOARD, '/vehicles/all'),
    add: path(ROOTS_DASHBOARD, '/vehicles/add'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/vehicles/edit/${id}`),
    import: path(ROOTS_DASHBOARD, '/vehicles/import'),
  },

  workers: {
    root: path(ROOTS_DASHBOARD, '/workers'),
    add: path(ROOTS_DASHBOARD, '/workers/add'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/workers/edit/${id}`),
    import: path(ROOTS_DASHBOARD, '/workers/import'),
  },

  newsletters: {
    root: path(ROOTS_DASHBOARD, '/newsletters'),
    viewAll: path(ROOTS_DASHBOARD, '/newsletters'),
    create: path(ROOTS_DASHBOARD, '/newsletters/create'),
  },

  subscriptions: {
    root: path(ROOTS_DASHBOARD, '/subscriptions'),
    viewAll: path(ROOTS_DASHBOARD, '/subscriptions'),
  },

  settings: {
    root: path(ROOTS_DASHBOARD, '/settings'),
    addUpdate: path(ROOTS_DASHBOARD, '/settings/add-update'),
  },
};


export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
